import '%/templates/template-map.scss';
import { GlobalEvents } from '@/models/events';

window.addEventListener(GlobalEvents.DOM_READY, () => {
  const map = document.querySelector('#map');
  const searchResults = document.querySelector('#list');
  const mobileTabNav = document.querySelector('#tabNav');
  const tabs =
    mobileTabNav?.querySelectorAll<HTMLInputElement>('input[data-toggle]');
  let activePanelId: string;

  const showActivePanel = (activePanelId: string) => {
    const activePanel = document.getElementById(activePanelId);
    activePanel && activePanel.classList.remove('mb-hidden');
    
    activePanelId === 'map' && searchResults?.classList.add('mb-hidden');
    activePanelId === 'list' && map?.classList.add('mb-hidden');
  };

  if (tabs) {
    tabs.forEach((tab) => {
      if (tab.checked) {
        activePanelId = tab.dataset.toggle || '';
      }
      tab.addEventListener('change', (e) => {
        activePanelId = (<HTMLElement>e.target)?.dataset?.toggle || '';
        showActivePanel(activePanelId);
      });
    });
  }
});
